import { Component, Inject, OnInit } from '@angular/core';

import { ShortDataLesson } from '@df/interfaces';
import { TeacherService } from '@app/teacher/services/teacher.service';
import { catchError, mergeMap, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/internal/Subject';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { of, throwError } from 'rxjs';

@Component({
    selector: 'app-delete-form',
    templateUrl: './delete-form.component.html',
    styleUrls: ['./delete-form.component.scss']
})
export class DeleteFormComponent implements OnInit {
    classTitle: string;
    lesson: ShortDataLesson;

    public lessonNumber: number;
    public lessonDate: Date;
    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
        private snackBar: MatSnackBar,
        @Inject(MAT_DIALOG_DATA) protected data: any,
        private dialogRef: MatDialogRef<DeleteFormComponent>,
        private teacherService: TeacherService
    ) {}

    public ngOnInit(): void {
        this.lesson = this.data.lesson;
        this.classTitle = this.data.classTitle;

        this.lessonNumber = this.lesson.lesson_number;
        this.lessonDate = this.lesson.date;
    }

    closeDeleteModal(data: any = null) {
        this.dialogRef.close(data);
    }

    public onSubmit(): void {
        this.teacherService
            .removeLesson(this.lesson.id)
            .pipe(
                takeUntil(this.destroy$),
                mergeMap(next => {
                    if (!next.response) {
                        return throwError(null);
                    }
                    return of(next);
                }),
                catchError(err => {
                    this.snackBar.open('Ошибка при удалении урока', 'Ok', {
                        duration: 2000
                    });
                    return throwError(err);
                })
            )
            .subscribe(() => {
                this.closeDeleteModal(this.lesson);
            });
    }
}
